import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ResourcesService } from 'app/services/resources.service';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-join-today',
  templateUrl: './join-today.component.html',
  styleUrls: ['./join-today.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JoinTodayComponent implements OnInit, OnDestroy {
  urlLogin = `${environment.appUrl}/auth/login`;
  urlSignUp = `${environment.appUrl}/auth/signup`;
  viewAlliances = false;
  partnershipsData = [];
  private _unsubscribeAll: Subject<any>;

  constructor(private resourcesService: ResourcesService) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  private init(): void {
    this.resourcesService.onPartnershipsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((data) => {
      if (data !== null && data.length > 0) {
        this.partnershipsData = data;
        this.viewAlliances = true;
      } else {
        this.partnershipsData = undefined;
        this.viewAlliances = false;
      }
    });
    this.resourcesService.getPartnerships();
  }
}
